import React from 'react';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import { Box, Container } from '@material-ui/core';
import TitleText from '../../components/reusableComponents/TitleText';
import FlightDealTable from '../../components/reusableComponents/FlightDealTable';
const FlightDealDetailPage = () => {
	return (
		<>
			<HeaderSection id={4} />
			<Box textAlign='center' mt={'120px'}>
				<TitleText textStyle={{ fontSize: 24, fontWeight: 500 }}>
					Special deal for the available dates for sector BLR - CCU Starting
					from
				</TitleText>
			</Box>
			<Container>
				<FlightDealTable />
			</Container>
		</>
	);
};

export default FlightDealDetailPage;
